import axios from "axios";
export const instance = axios.create();
instance.defaults.baseURL = "http://20.244.16.40:8001";
